import Pons from "../../../../media/img/service/Pons.png";
import Evidenze from "../../../../media/img/service/Evidenze.png";
import mbit from "../../../../media/img/service/mbit.png";
import IFFE from "../../../../media/img/service/IFFE.png";
import DUONEX from "../../../../media/img/service/DUONEX.png";
import dave from "../../../../media/img/service/dave.png";
import medgon from "../../../../media/img/service/medgon.png";
import brico from "../../../../media/img/service/brico.png";
import tyris from "../../../../media/img/service/tyris.png";
import tyristech from "../../../../media/img/service/tyristech.png";
import BERS from "../../../../media/img/service/BERS.png";




export const clientesLogos = [
    { id: 1, photo: Pons },
    { id: 2, photo: Evidenze },
    { id: 3, photo: mbit },
    { id: 4, photo: IFFE },
    { id: 5, photo: DUONEX },
    { id: 6, photo: dave },
    { id: 7, photo: medgon },
    { id: 8, photo: brico },
    { id: 6, photo: tyris },
    { id: 7, photo: tyristech },
    { id: 8, photo: BERS },
];